/**
 * Model konfiguracyjny definiujący pojedynczy przycisk akcji w uniwersalnej tabeli danych (DataGrid).
 * Pozwala na dynamiczne wstrzykiwanie logiki biznesowej, stylów oraz reguł dostępu
 * bezpośrednio do generycznego komponentu widoku, bez konieczności jego modyfikacji.
 */
export class DataGridActionButtonDef {

  /** Etykieta tekstowa wyświetlana na przycisku. */
  public label: string;

  /** Kolor przycisku z palety systemowej (np. 'primary', 'danger', 'medium'). */
  public color: string;

  /** Funkcja zwrotna (Callback / Closure) wykonywana po kliknięciu przycisku.
   * Generyczny typ 'any' pozwala na przekazanie dowolnej logiki, włączając w to
   * strzały do API oraz manipulację stanem aplikacji. Jako argument przyjmuje dane wiersza.
   */
  public action: any;

  /** Opcjonalny mechanizm (np. Observable lub EventEmitter) wymuszający ponowną
   * ewaluację stanu dostępności przycisku w czasie rzeczywistym.
   */
  public enabledTrigger: any;

  /** Flaga lub funkcja ewaluacyjna określająca, czy przycisk ma być klikalny (disabled state).
   * Pozwala na warunkowe blokowanie akcji na podstawie danych konkretnego wiersza.
   */
  public isEnabled: any;

  /** Treść pytania wyświetlanego w systemowym oknie dialogowym (Confirmation Alert)
   * przed faktycznym wywołaniem funkcji `action`. Zabezpiecza przed przypadkowym kliknięciem.
   */
  public actionConfirmationQuestion: string;

  /** Flaga określająca, czy akcja jest dozwolona dla rekordów, które zostały
   * oznaczone jako usunięte w bazie danych.
   */
  public enabledForDeletedObjects: boolean;

  /** Opcjonalna nazwa ikony (z biblioteki ionicons) do wyrenderowania wewnątrz przycisku. */
  public icon: string;

  constructor(
    label: string,
    color: string,
    action: any,
    enabledTrigger: any,
    isEnabled: any,
    enabledForDeletedObjects: boolean = false,
    confirmationQuestion: string = null,
    icon: string = null
  ) {
    this.label = label;
    this.color = color;
    this.action = action;
    this.enabledTrigger = enabledTrigger;
    this.isEnabled = isEnabled;
    this.enabledForDeletedObjects = enabledForDeletedObjects;
    this.actionConfirmationQuestion = confirmationQuestion;
    this.icon = icon;
  }
}
